/** Preserve the first referral before navigation removes the landing-page query. */
export function captureLandingReferral(): void {
    try {
        const referral = new URLSearchParams(window.location.search).get('ref');
        if (referral && !window.localStorage.getItem('tgp_ref_code')) {
            window.localStorage.setItem('tgp_ref_code', referral);
        }
    } catch {
        // Storage restrictions must not prevent the public page from loading.
    }
}
